import React, { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import phoneImage from "../assets/images/phone.png";
import API_ENDPOINTS from "../config/api";

const PhoneNumber = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { fullname, email, account, token } = location.state || {};

  const [phoneNumber, setPhoneNumber] = useState("");
  const [selectedCountry, setSelectedCountry] = useState("Kenya");
  const [errorMessage, setErrorMessage] = useState("");

  useEffect(() => {
    const disableRightClick = (e) => e.preventDefault();
    document.addEventListener("contextmenu", disableRightClick);

    return () => {
      document.removeEventListener("contextmenu", disableRightClick);
    };
  }, []);

  // Country codes for validation and placeholder
  const countryCodes = {
    Kenya: "+254",
  };

  // Validate phone number based on selected country
  const validatePhoneNumber = (number) => {
    const countryCode = countryCodes[selectedCountry];
    return (
      number.startsWith(countryCode) &&
      number.length === 13 &&
      !number.includes(" ")
    );
  };

  const saveUserDetails = async () => {
    if (!validatePhoneNumber(phoneNumber)) {
      setErrorMessage(
        `Phone number must start with ${countryCodes[selectedCountry]}, not contain spaces, and be 13 characters long.`
      );
      return;
    }

    try {
      const response = await axios.post(
        API_ENDPOINTS.SAVE_USER,
        {
          fullname,
          email,
          account,
          token,
          phone: phoneNumber,
          country: selectedCountry,
        }
      );

      if (response.status === 201 || response.status === 200) {
        toast.success("User saved successfully!");
        navigate("/create_password", { state: { email, account } });
      } else if (response.status === 409) {
        toast.info("User already exists. Redirecting to sign-in page...");
        setTimeout(() => navigate("/signin"), 3000);
      } else {
        toast.error("Failed to save user");
      }
    } catch (error) {
      console.error("Error saving user details:", error);
      if (error.response?.status === 403) {
        toast.error(error.response.data.error);
        setTimeout(() => navigate("/signin"), 3000);
      } else if (error.response?.status === 409) {
        toast.info("User already exists. Redirecting to sign-in page...");
        setTimeout(() => navigate("/signin"), 3000);
      } else {
        toast.error("An error occurred while saving user details");
      }
    }
  };

  return (
    <div className="min-h-screen flex flex-col items-center justify-center p-4 bg-gray-50">
      <ToastContainer position="top-right" autoClose={3000} hideProgressBar />

      <header className="bg-teal-600 w-full p-4 text-white text-center text-2xl font-bold">
        Phone Number
      </header>

      <div className="w-full max-w-lg bg-white rounded-lg shadow-md p-6 text-center mt-4 lg:mt-8">
        <img
          src={phoneImage}
          alt="Phone"
          className="mx-auto mb-6 w-1/2 sm:w-1/3 md:w-1/4 lg:w-1/5"
        />

        <h1 className="text-2xl font-bold mb-4">Phone Number</h1>
        <p className="mb-4">
          Please select your country and enter your phone number.
        </p>

        <select
          value={selectedCountry}
          onChange={(e) => {
            setSelectedCountry(e.target.value);
            setPhoneNumber("");
            setErrorMessage("");
          }}
          className="w-full p-3 border rounded-md mb-4 text-sm lg:text-base"
        >
          {Object.keys(countryCodes).map((country) => (
            <option key={country} value={country}>
              {country}
            </option>
          ))}
        </select>

        <input
          type="tel"
          value={phoneNumber}
          onChange={(e) => {
            // Automatically remove spaces from input
            const sanitizedNumber = e.target.value.replace(/\s/g, "");
            setPhoneNumber(sanitizedNumber);
            setErrorMessage(""); // Clear error when user types
          }}
          placeholder={`${countryCodes[selectedCountry]}...`}
          className="w-full p-3 border rounded-md mb-2 text-sm lg:text-base"
        />
        {errorMessage && (
          <p className="text-red-500 mb-4 text-sm lg:text-base">
            {errorMessage}
          </p>
        )}

        <button
          onClick={saveUserDetails}
          className="w-full bg-teal-600 text-white py-2 rounded-md text-lg font-semibold mb-3 hover:bg-teal-700 transition"
        >
          Continue
        </button>

        <button
          onClick={() => navigate("/signup")}
          className="w-full text-teal-600 py-2 rounded-md text-lg font-semibold hover:text-teal-800 transition"
        >
          Cancel Sign Up
        </button>
      </div>
    </div>
  );
};

export default PhoneNumber;
